import { SC_SET_SUBMISSION } from '@/store/mutation-types';
import { SC_COPY_SUBMISSION } from '@/store/action-types';

const state = {
  submission: localStorage['submission_clipboard'] || '',
}

const getters = {
  getCopiedSubmission: state => state.submission,
}

const mutations = {
  SC_SET_SUBMISSION: function(state, submission){
    state.submission = submission;
    localStorage['submission_clipboard'] = submission;
    //window.$cookies.set('submission_clipboard', submission);
  },
}

const actions = {

  SC_COPY_SUBMISSION: ({commit}, {submission}) => {
    return commit(SC_SET_SUBMISSION, submission);
  }

}

export default {
  getters,
  mutations,
  actions,
  state
}
